// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
li[data-v-edd54cf2] {
    margin-inline-start: 1.25em;
}
.markdown-tool[data-v-edd54cf2] a {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/RecipeView/RecipeTool.vue"],"names":[],"mappings":";AAsBA;IACA,2BAAA;AACA;AAEA;IACA,0BAAA;AACA","sourcesContent":["<template>\n    <li>\n        <VueShowdown :markdown=\"tool\" class=\"markdown-tool\" />\n    </li>\n</template>\n\n<script setup>\ndefineProps({\n    tool: {\n        type: String,\n        default: '',\n    },\n});\n</script>\n\n<script>\nexport default {\n    name: 'RecipeTool',\n};\n</script>\n\n<style scoped>\nli {\n    margin-inline-start: 1.25em;\n}\n\n.markdown-tool:deep(a) {\n    text-decoration: underline;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
